<template>
  <!-- Page Content-->
  <div class="container-fluid p-0">
    <!-- About-->
    <About />
    <hr class="m-0" />
    <!-- Experience-->
    <Experiences />
    <hr class="m-0" />
    <!-- Education-->
    <Educations />
    <hr class="m-0" />
    <!-- Skills-->
    <Skills />
    <hr class="m-0" />
    <!-- Interests-->
    <Interests />
    <hr class="m-0" />
    <!-- Portfolio-->
    <Portfolio />
    <hr class="m-0" />
    <!-- Portfolio Modal-->
    <PortfolioModal />
    <!-- Awards-->
    <Awards />
  </div>
</template>

<script>
import About from "./About.vue";
import Experiences from "./Experiences.vue";
import Educations from "./Educations.vue";
import Skills from "./Skills.vue";
import Interests from "./Interests.vue";
import Portfolio from "./Portfolio.vue";
import PortfolioModal from "./PortfolioModal.vue";
import Awards from "./Awards.vue";

export default {
  components: {
    About,
    Experiences,
    Educations,
    Skills,
    Interests,
    Portfolio,
    PortfolioModal,
    Awards,
  },
};
</script>
